import React, { useState } from 'react'
import AppFrame from '../AppFrame'
import { useQuery } from "@apollo/client"
import { get, filter, find, map, sortBy } from 'lodash'

import { QUERY_ABOUT_DATA } from '../data/services/graphqlQueries'
import BioThumb from '../components/BioThumb'
import PageHeader from '../components/PageHeader'
import SectionHeader from '../components/SectionHeader'
import SplashImage from '../components/SplashImage'

export default ({globalData, clinic}) => {
  const { loading, error, data } = useQuery(QUERY_ABOUT_DATA, {
    notifyOnNetworkStatusChange: true
  });
  const [pageDescription, setPageDescription] = useState(null)
  const [doctorBios, setDoctorBios] = useState(null)
  const [staffBios, setStaffBios] = useState(null)

  React.useEffect(() => {
    if (data) {
      const pd = find(data.pageDescriptions, (pd) => {
        return pd.clinic === (clinic ? clinic.url : null)
      })

      setPageDescription(pd)

      const doctors = filter(data.bios, (b) => {
        const categoryMatch = b.category === 'doctor'
        if (clinic) {
          return b.locations.includes(clinic.url) && categoryMatch
        } else {
          return categoryMatch
        }
      })
      setDoctorBios(sortBy(doctors, ['priority', 'name']))

      const staff = filter(data.bios, (b) => {
        const categoryMatch = b.category === 'staff'
        if (clinic) {
          return b.locations.includes(clinic.url) && categoryMatch
        } else {
          return categoryMatch
        }
      })
      setStaffBios(sortBy(staff, ['priority', 'name']))
    }
  }, [clinic, data])

  if (loading || !pageDescription) {
    return (
      <AppFrame data={globalData}>
        <div className="max-w-6xl mx-auto px-4 pb-8 min-h-[400px]">
          loading
        </div>
      </AppFrame>
    )
  }



  return (
    <AppFrame data={globalData}>
      <SplashImage image={get(pageDescription, 'image.url')} imageMobile={get(pageDescription, 'imageMobile.url')} />
      <div className="max-w-6xl mx-auto px-4 pb-8 min-h-[400px]">
        <div className="my-8">
          <PageHeader title={pageDescription.title} subtitle="About" />
          <div dangerouslySetInnerHTML={{__html: pageDescription.body}} className="text-sm leading-8 ml-auto max-w-xl md:text-normal ecs-html"></div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <SectionHeader title={'Doctors'} subtitle={clinic ? clinic.name : 'Eye Clinics of Seattle'} />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {
          map(doctorBios, (doctor, index) => {
            return (
              <BioThumb key={`doctor-${index}`} bioData={doctor}></BioThumb>
            )
          })
        }
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <SectionHeader title={'Staff'} subtitle={clinic ? clinic.name : 'Eye Clinics of Seattle'} />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {
            map(staffBios, (staff, index) => {
              return (
                <BioThumb key={`staff-${index}`} bioData={staff}></BioThumb>
              )
            })
          }
        </div>
      </div>
    </AppFrame>
  )
}